import { createTheme } from '@mui/material/styles';
import { Brightness1 } from "@mui/icons-material";

export const theme = createTheme({
    breakpoints: {
        values: {
            xs: 380,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400,
        },
    },
});

export const getStatus = (status) => {
  if(status) return [
    <Brightness1 key={status} style={{ color: "#14BD62", fontSize: 8, marginBottom: 4, marginRight: 6 }}/>,
    "Идэвхитэй карт"
  ]; else return [
    <Brightness1 key={status} style={{ color: "#DF2647", fontSize: 8, marginBottom: 4, marginRight: 6 }}/>,
    "Идэвхигүй карт"
  ]; 
}